<template>
  <b-container>

    <b-row>
      <b-col>
      <BaseRadioInput v-model="haveApp"
                     :v="$v.haveApp"
                     :label="$t('labels.haveApp')"
                     :options="yesNoOptions"
                     setId="haveApp"
                     slug="haveApp"/>
        </b-col>
    </b-row>

  <div v-if="haveApp === 'Y'">
    <b-row>
      <b-col>
        <p class="h5 mb-4" v-html="$t('html.covidAwareApp')"></p>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
      <BaseRadioInput v-model="sendCode"
                     :v="$v.sendCode"
                     :label="$t('labels.sendCode')"
                     :options="yesNoOptions"
                      setId="sendCode"
                     slug="sendCode"/>
      </b-col>
    </b-row>


    <b-row v-if="sendCode === 'Y'">
      <b-col cols="12" lg="6">
        <BaseMaskedTextInput v-model="appPhoneNumber"
                       :v="$v.appPhoneNumber"
                       :label="$t('labels.appPhoneNumber')"
                       mask="(###)###-####"
                       slug="appPhoneNumber"/>
      </b-col>
    </b-row>
    </div>
  </b-container>
</template>

<script>
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'


export default {
  components: {},
  mixins: [
       commonOptions
    ],
  data: () => ({
    haveApp: null,
    sendCode: null,
    appPhoneNumber: '',
    appEmailAddress: '',
  }),
  validations() {
    return {
      haveApp: { required: false },
      sendCode: { required: false },
      appPhoneNumber: { required: false, maxLength: maxLength(15),
        isValid(tel) {
          var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
          return phoneRegex.test(tel) || tel === ''
        }
      },
      appEmailAddress: { required: false, email, maxLength: maxLength(100)  },
      form: [ 'haveApp', 'sendCode','appPhoneNumber' ]
    }
  },
  watch: {
  },
  methods: {
    validate() {
      this.$v.form.$touch()
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },
  }
}
</script>

<style>

ol {
  display: block;
}

li {
  display: list-item;
  margin-bottom: .5rem;
}

#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #4bc5e8);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

</style>
